import { connectFela } from '../../../../dependencies';
import FlexibeeService from './FlexibeeService';
import * as styles from './FlexibeeService.styles';

export default connectFela(styles)(FlexibeeService);
